<template>
  <CHeader position="sticky" class="mb-4">
    <CContainer fluid>
      <CHeaderToggler class="ps-1" @click="$store.commit('toggleSidebar')">
        <CIcon icon="cil-menu" size="lg" />
      </CHeaderToggler>
      <!-- <CHeaderBrand class="mx-auto d-lg-none" to="/">
        <img
          src="https://www.ptppi.co.id/wp-content/uploads/2022/01/PPI-ID-Food.png"
          alt="Logo"
          style="max-width: 100px"
        />
        <CIcon icon="cil-menu" size="lg" />
      </CHeaderBrand>
      <CHeaderNav class="d-none d-md-flex me-auto">
        <CNavItem>
          <CNavLink href="/dashboard"> Dashboard </CNavLink>
        </CNavItem>
        <CNavItem>
          <CNavLink href="#">Users</CNavLink>
        </CNavItem>
        <CNavItem>
          <CNavLink href="#">Settings</CNavLink>
        </CNavItem>
      </CHeaderNav> -->
      <CHeaderNav>
        <!-- <CNavItem>
          <CNavLink href="#">
            <CIcon class="mx-2" icon="cil-bell" size="lg" />
          </CNavLink>
        </CNavItem>
        <CNavItem>
          <CNavLink href="#">
            <CIcon class="mx-2" icon="cil-list" size="lg" />
          </CNavLink>
        </CNavItem> -->
        <NotifikasiLonceng v-if="tampilLonceng" />
        <!-- Menu akun: dulu klik nama langsung keluar, sekarang dropdown agar tidak logout tanpa sengaja -->
        <CDropdown variant="nav-item" placement="bottom-end">
          <!-- CoreUI merender toggle nav-item sebagai <a href="#">: tanpa .prevent, router hash pindah ke "/" (dashboard) -->
          <CDropdownToggle class="d-flex align-items-center gap-2 py-0" :caret="false" @click.prevent>
            <AvatarFoto :foto="fotoSaya.path" :nama="nama" :size="32" />
            <span class="d-none d-sm-inline">{{ nama }}<span v-if="unit" class="text-body-secondary"> | {{ unit }}</span></span>
            <CIcon icon="cil-chevron-bottom" size="sm" />
          </CDropdownToggle>
          <CDropdownMenu class="pt-0">
            <CDropdownHeader class="bg-body-secondary fw-semibold py-2 d-sm-none">{{ nama }}</CDropdownHeader>
            <CDropdownItem component="button" type="button" @click="$router.push(ruteProfil)"><CIcon icon="cil-user" class="me-2" />Profil Saya</CDropdownItem>
            <CDropdownItem component="button" type="button" @click="$router.push(rutePassword)"><CIcon icon="cil-lock-locked" class="me-2" />Ganti Password</CDropdownItem>
            <CDropdownDivider />
            <CDropdownItem component="button" type="button" @click="logout()"><CIcon icon="cil-account-logout" class="me-2" />Keluar</CDropdownItem>
          </CDropdownMenu>
        </CDropdown>
        <!-- <AppHeaderDropdownAccnt /> -->
      </CHeaderNav>
    </CContainer>
    <CHeaderDivider />
    <CContainer fluid>
      <AppBreadcrumb />
    </CContainer>
  </CHeader>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'
import AppBreadcrumb from './AppBreadcrumb'
import AvatarFoto from './AvatarFoto.vue'
import NotifikasiLonceng from './NotifikasiLonceng.vue'
import { fotoSaya, setFotoSaya } from '@/utils/foto'
import { logout as keluar } from '@/utils/auth'
import { logo } from '@/assets/brand/PPI-ID-Food.png'
export default {
  name: 'AppHeader',
  components: {
    AppBreadcrumb,
    AvatarFoto,
    NotifikasiLonceng,
  },
  setup() {
    return { logo, fotoSaya }
  },
  data() {
    const role = localStorage.getItem('role_id')
    return {
      nama: localStorage.getItem('nama'),
      unit: localStorage.getItem('unit'),
      // Karyawan memakai halaman ESS yang sudah ada (lengkap dengan data pribadi & keluarga)
      ruteProfil: role === '4' ? '/ess/profil' : '/akun/profil',
      rutePassword: { path: '/akun/profil', hash: '#ganti-password' },
      // Notifikasi saat ini hanya pengingat faktur pajak, untuk akun pajak
      tampilLonceng: ['1', '2', '3', '4', '8', '9'].includes(role),
    }
  },
  created() {
    window.addEventListener('wina-profil', this.segarkanNama)
  },
  beforeUnmount() {
    window.removeEventListener('wina-profil', this.segarkanNama)
  },
  mounted() {
    // Segarkan foto (mis. baru diganti admin, atau sesi login lama yang belum menyimpan foto)
    const url = localStorage.getItem('url')
    // Akun UMKM, praktik bidan, dan pajak tidak punya data kepegawaian
    if (!url || ['5', '6', '7', '8', '9', '10'].includes(localStorage.getItem('role_id'))) return
    axios
      .post(url + 'kepegawaian/foto_saya', {}, { headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-API-KEY': localStorage.getItem('key') } })
      .then((res) => {
        if (res.data.status === 'success') setFotoSaya(res.data.foto)
      })
      .catch(() => {})
  },
  methods: {
    segarkanNama() {
      this.nama = localStorage.getItem('nama')
    },
    async logout() {
      const ok = await swal({ title: 'Keluar dari aplikasi?', icon: 'warning', buttons: ['Batal', 'Keluar'] })
      if (!ok) return
      // Cabut token di server lalu bersihkan sesi (src/utils/auth.js)
      keluar()
    },
  },
}
</script>
